import Link from "@components/Theme/Link/Link"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import ExternalIcon from "@components/icons/ExternalIcon"
import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Image from "next/image"
import {useRouter} from "next/router"
import React from "react"

import styles from "./HeaderHoverOld.module.scss"
type Props = {
	data: MenuModuleType[]
	last: undefined | "last"
}

const HeaderHoverOld = (props: Props) => {
	const router = useRouter()

	return (
		<div className={`${styles.hoveredMenu} ${styles[props.last ?? ""]}`}>
			<div className={styles.hoveredMenuBox}>
				<div className={styles.hoveredMenuWrapper}>
					{/* <h2 className={styles.hoveredTitle}>
									{subMenu.menuTitle}
								</h2> */}
					<ul>
						{props.data?.map(
							(subMenu: MenuModuleType, subMenuIndex: number) => {
								// return (
								// 	<>
								// 		{subMenu.children?.map(
								// 			(
								// 				subMenuChildren: MenuModuleType,
								// 				subMenuChildrenIndex: number,
								// 			) => {

								const external = subMenu.link?.includes("http")

								const {current, parent} = checkIfLinkIsCurrent(
									router.asPath,
									subMenu.link,
									subMenu.subLinksSelect,
								)
								const active =
									current || parent ? styles.active : ""
								return (
									<li
										key={subMenuIndex}
										className={styles.hoveredListItem}
									>
										<Link
											className={`${styles.hoveredLink} ${active}`}
											link={subMenu.link}
											withoutTarget
										>
											<Typography
												noPadding
												variant={Variant.Description}
												className={styles.linkTitle}
												fontWeight={400}
											>
												{subMenu?.menuLinkIconSvg && (
													<div
														className={styles.logo}
													>
														<Image
															{...subMenu.menuLinkIconSvg}
															className={
																styles.LogoImage
															}
															width={
																subMenu
																	.menuLinkIconSvg
																	?.width ||
																1920
															}
															height={
																subMenu
																	.menuLinkIconSvg
																	?.height ||
																1024
															}
														/>
													</div>
												)}
												{!subMenu?.menuLinkIconSvg &&
													subMenu.menuTitle}
												{external && (
													<ExternalIcon
														className={
															styles.svgIcon
														}
													/>
												)}
											</Typography>

											{subMenu.subtitle && (
												<Typography
													noPadding
													className={
														styles.descriptionText
													}
													content={subMenu.subtitle}
													variant={
														Variant.Description
													}
												/>
											)}
										</Link>
									</li>
								)
								// 		},
								// 	)}
								// </>
								// )
							},
						)}
					</ul>
				</div>
			</div>
		</div>
	)
}

export default HeaderHoverOld
